import React from "react";

const Dialog = ({ 
  isOpen, 
  onClose, 
  hasActiveSubscription, 
  onSave, 
  title, 
  children, 
  leftButton, 
  rightButton, 
  needSpace = true,
  whiteCrossButton = false, 
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ${needSpace ? "p-4" : ''}`}>
      {/* Dialog Box */}
      <div className={`bg-white rounded-2xl shadow-lg w-auto min-w-[280px] max-w-[90vw] ${needSpace ? "p-6" : ''} relative animate-fadeIn`}>
        {/* Close Button */}
        <button
          className={`absolute top-3 right-3 ${whiteCrossButton ? "text-white" : "text-gray-700"}`}
          onClick={onClose}
        >
          ✕
        </button>

        {/* Title */}
        {title && (
          <h2 className="text-xl font-semibold text-gray-800 mb-4 pr-6">{title}</h2>
        )}

        {/* Content */}
        <div className={`text-gray-600 ${needSpace ? "mb-6" : ''} max-h-[95vh] overflow-y-auto`}>{children}</div>

        {/* Footer */}
        {hasActiveSubscription &&
          <div className="flex justify-end gap-3">
            <button
              disabled={isLoading}
              onClick={onClose}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              {leftButton}
            </button>
            <button
              disabled={isLoading}
              onClick={onSave}
              className="px-4 py-2 rounded-lg bg-[#FA6138] text-white hover:bg-[#ff724d]"
            >
              {rightButton}
            </button>
          </div>
        }
      </div>
    </div>
  );
};

export default Dialog;